module.exports = __webpack_public_path__ + "1d22adf3b6702d865c58d4c7846931b0.MP3";